import { BodyRowType, IconType, OfferingTypeConfig } from '../utils/types';
import { getVirtualTrainingRows } from '../BodyBuilder/utils';
import { livePremiumSessionCourseIconConfig } from './livePremiumSessionCourse';

const liveEventsConfig: OfferingTypeConfig = {
  actionButtons: ({ liveEventInfo, routerStore, t }) => {
    const routeName = 'classes:view';
    const routeParams = { uuid: liveEventInfo?.id };

    return {
      actionButtonA: {
        buttonLabel: t('View'),
        href: routerStore.router.buildUrl(routeName, routeParams),
        icon: IconType.Arrow,
        onClick: () => routerStore.navigate(routeName, routeParams),
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Custom],
  buildCustomRows: ({ liveEventInfo, t }) => {
    if (liveEventInfo?.type === 'vt' || liveEventInfo?.type === 'ilt')
      return getVirtualTrainingRows(t, liveEventInfo?.startTime);
    return [];
  },
  headerConfig: ({ t }) => ({
    iconB: livePremiumSessionCourseIconConfig,
    title: t('Virtual training'),
  }),
};

export default liveEventsConfig;
